module.exports = __webpack_public_path__ + "static/media/medicationManagement.d67dc3cf.png";